<template>
  <b-modal
    id="rename-modal"
    title="Rename"
    @ok="$emit('change', name)"
    @close="$emit('close')"
  >
    <b-form-input v-model="name" />
  </b-modal>
</template>

<script>
export default {
  name: 'RenameModal',
  
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  
  data: () => ({
    name: ''
  }),
  
  watch: {
    item(value) {
      if (value) {
        this.name = value.name
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
